var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAdvertiser01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Manage Advertiser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.84,14.41,8.68,20.9a.48.48,0,0,0,.53.22l1.62-.38a.48.48,0,0,0,.31-.7l-3-5.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.13,10.2H3.38a0,0,0,0,1,0,0v4.51a0,0,0,0,1,0,0H1.94a.85.85,0,0,1-.85-.85V11.24a1,1,0,0,1,1-1Z",
    transform: "translate(-2.81 0.85) rotate(-13.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3,9.92s8.9-4.39,10.43-6.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,14.42s10.19-.13,12.38.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,5.09l-.44-1.86a.72.72,0,0,1,.53-.86L16,1.91a.71.71,0,0,1,.86.53l3,12.66a.72.72,0,0,1-.54.86l-1.95.46a.7.7,0,0,1-.86-.53L14.47,7.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.51,
    y1: 5.61,
    x2: 20.99,
    y2: 4.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 20.62,
    y1: 10.3,
    x2: 22.31,
    y2: 10.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.05,
    y1: 7.91,
    x2: 23.19,
    y2: 7.17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAdvertiser01);
export default __webpack_public_path__ + "static/media/Manage_Advertiser_01.c597e7a75d0a2e6de02e622473866a96.svg";
export { ForwardRef as ReactComponent };